<template>
    <Fragment>
        <AppSummary
            title_summary="Vendedor"
            :collapses="collapses"
            v-if="showSellerFieldAtCheckout"
        >
            <template #employee-shipping-collapse>
                <!-- Link de vendedor: sem lista, o cliente cola o link ou digita o codigo -->
                <template v-if="affiliateLinkEnabled">
                    <template v-if="employee && employee.value">
                        <input
                            type="text"
                            class="form-control form-control-sm"
                            :value="employee.label"
                            readonly
                        />
                        <small class="employee-locked-hint">
                            {{ source === 'carteira' ? 'Vendedor responsável pela sua conta.' : 'Vendedor definido pelo link de atendimento.' }}
                        </small>
                    </template>
                    <form v-else @submit.prevent="applyAffiliateCode">
                        <div class="input-group">
                            <input
                                type="text"
                                v-model="affiliateCode"
                                class="form-control form-control-sm"
                                placeholder="Cole o link ou digite o código do vendedor"
                                :style="'height: 3.8rem; margin-right: 13px; font-family:'+$root.$children[0].theme.font_family"
                            />
                            <div class="input-group-append">
                                <c-button
                                    :backgroundColor="$root.$children[0].theme.products.button.background_color"
                                    :backgroundColorHover="$root.$children[0].theme.products.button.background_color_hover"
                                    :color="$root.$children[0].theme.products.button.color"
                                    :colorHover="$root.$children[0].theme.products.button.color_hover"
                                    :borderColor="$root.$children[0].theme.products.button.border_color"
                                    :borderColorHover="$root.$children[0].theme.products.button.border_color_hover"
                                    :borderRadius="$root.$children[0].theme.products.button.border_radius"
                                    :textTransform="$root.$children[0].theme.products.button.text_transform"
                                    type="submit"
                                    margin="unset"
                                    height="3.8rem"
                                >
                                    Aplicar
                                </c-button>
                            </div>
                        </div>
                        <small v-if="affiliateError" class="employee-code-error">
                            {{ affiliateError }}
                        </small>
                    </form>
                </template>
                <v-select
                    v-else
                    v-model="employee"
                    class="input-select"
                    placeholder="Nenhum vendedor selecionado"
                    :options="paginated"
                    :filterable="false"
                    @open="onOpen"
                    @close="onClose"
                    @search="query => (search = query)"
                >
                    <template #no-options>
                        Nenhum vendedor encontrado.
                    </template>
                    <template #list-footer>
                        <li v-show="hasNextPage" ref="load" class="loader">
                            Carregando...
                        </li>
                    </template>
                </v-select>
            </template>
        </AppSummary>
    </Fragment>
</template>

<script>
import AppSummary from "../AppSummary.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import { Fragment } from "vue-fragment";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { CButton } from "../Styles/Button/styled";

export default {
    name: "EmployeeCheckout",
    components: {
        AppSummary,
        Fragment,
        vSelect,
        "c-button": CButton
    },
    data() {
        return {
            observer: null,
            limit: 10,
            search: "",
            total: 0,
            employee: null,
            locked: false,
            source: null,
            affiliateCode: "",
            affiliateError: null,
            close: true,
            collapses: [
                {
                    title: "Teve ajuda de algum vendedor? Se sim, qual?",
                    id: "employee-shipping-collapse",
                    collapsed: true
                }
            ]
        };
    },
    mounted() {
        this.observer = new IntersectionObserver(this.infiniteScroll);
        this.getEmployee();
    },
    methods: {
        ...mapActions("employee", [
            "ActionGetEmployees",
            "ActionGetEmployee",
            "ActionSetEmployees",
            "ActionSetEmployee",
            "ActionSetAffiliateCode",
            "setEmployee"
        ]),
        getEmployee() {
            this.ActionGetEmployee()
                .then(response => {
                    this.locked = !!response.locked;
                    this.source = response.source ?? null;
                    this.employee = response.data;
                })
                .catch(error => alert(error));
        },
        applyAffiliateCode() {
            this.affiliateError = null;
            if (!this.affiliateCode.trim()) {
                return;
            }
            this.ActionSetAffiliateCode({ code: this.affiliateCode })
                .then(response => {
                    this.locked = true;
                    this.source = "link";
                    this.employee = response.data;
                })
                .catch(error => {
                    this.affiliateError = error?.msg ?? "Código de vendedor não encontrado.";
                });
        },
        async onOpen() {
            this.close = false;
            await this.getEmployees();
            if (this.hasNextPage) {
                await this.$nextTick();
                this.observer.observe(this.$refs.load);
            }
        },
        onClose() {
            this.close = true;
            this.observer.disconnect();
        },
        async infiniteScroll([{ isIntersecting, target }]) {
            if (isIntersecting) {
                const ul = target.offsetParent;
                const scrollTop = target.offsetParent.scrollTop;
                this.limit += 10;
                await this.getEmployees();
                await this.$nextTick();
                ul.scrollTop = scrollTop;
            }
        },
        async getEmployees() {
            let filters = this.getFilters();
            await this.ActionGetEmployees(filters)
                .then(response => {
                    this.total = response.data.total;
                    this.ActionSetEmployees(response.data.data);
                })
                .catch(error => alert(error));
        },
        getFilters() {
            return {
                search: this.search,
                limit: this.limit
            };
        }
    },
    watch: {
        // As settings da loja chegam no store depois do created.
        affiliateLinkEnabled: {
            immediate: true,
            handler(enabled) {
                this.collapses[0].title = enabled
                    ? "Tem o link ou código do vendedor?"
                    : "Teve ajuda de algum vendedor? Se sim, qual?";
            }
        },
        search() {
            if (!this.close) {
                this.getEmployees();
            }
        },
        employee(employee) {
            this.setEmployee(employee);
            // Com o link de vendedor ligado o cliente nao escolhe vendedor.
            if (!this.locked && !this.affiliateLinkEnabled) {
                this.ActionSetEmployee(employee);
            }
        }
    },
    computed: {
        ...mapState("employee", ["employees"]),
        ...mapState("clients", ["clientLogged", "client"]),
        ...mapGetters("company", ["showSellerFieldAtCheckout", "affiliateLinkEnabled"]),
        paginated() {
            return this.employees;
        },
        hasNextPage() {
            return this.paginated.length < this.total;
        }
    }
};
</script>

<style scoped>
.employee-locked-hint {
    display: block;
    margin-top: 6px;
    color: #6c757d;
}
.employee-code-error {
    display: block;
    margin-top: 6px;
    color: #dc3545;
}
</style>
